import './App.css'

function App() {
  return (
    <>
      <h1>SparkServ Integration</h1>
      <p className="version">v{APP_VERSION}</p>
    </>
  )
}

export default App
